import RegisterForm from "../Components/forms/RegisterForm";


const Register = () => {
    return (
        <div className="min-h-screen">
            <h2 className="text-3xl text-center my-6">Registrarse</h2>
            <RegisterForm/>
        </div>
    );
}

export default Register;
